import { useEffect, useId, useState } from 'react'
import { Info } from 'lucide-react'
import { coarsePointer } from '@/lib/mobile'
import { TooltipBubble } from './Tooltip'
import styles from './InfoTip.module.css'

/** Значок (i) с коротким пояснением: по наведению, фокусу или нажатию — на телефоне наведения нет. */
export function InfoTip({ text, label = 'Подробнее' }: { text: string; label?: string }) {
  const [open, setOpen] = useState(false)
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null)
  const id = useId()
  // A portal keeps even the open explanation out of the card's scrollable width.
  useEffect(() => {
    if (!open) return
    const close = () => setOpen(false)
    const outside = (event: PointerEvent) => { if (!anchor?.contains(event.target as Node)) close() }
    const escape = (event: KeyboardEvent) => { if (event.key === 'Escape') close() }
    document.addEventListener('pointerdown', outside, true)
    document.addEventListener('keydown', escape, true)
    document.addEventListener('scroll', close, true)
    window.addEventListener('resize', close)
    return () => {
      document.removeEventListener('pointerdown', outside, true)
      document.removeEventListener('keydown', escape, true)
      document.removeEventListener('scroll', close, true)
      window.removeEventListener('resize', close)
    }
  }, [open, anchor])
  return (
    <span className={styles.wrap} onMouseEnter={coarsePointer ? undefined : () => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button
        ref={setAnchor}
        type="button"
        className={styles.button}
        aria-label={label}
        aria-expanded={open}
        onClick={(e) => {
          e.stopPropagation()
          setOpen((v) => !v)
        }}
        onFocus={(e) => { if (e.currentTarget.matches(':focus-visible')) setOpen(true) }}
        onKeyDown={(e) => e.stopPropagation()}
        onBlur={() => setOpen(false)}
      >
        <Info size={15} aria-hidden="true" />
      </button>
      {open && anchor ? <TooltipBubble anchor={anchor} content={text} id={id} /> : null}
    </span>
  )
}
